module.exports = __webpack_public_path__ + "static/img/standardPic2.52f9ea71.png";